// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mask-preview[data-v-09033ad2]{width:100%;height:100%;background:#000;display:flex;align-items:center;justify-content:center}.mask-preview__image-group[data-v-09033ad2]{position:absolute;top:0;bottom:0;left:0;right:0;opacity:.2;background-size:100% 100%}.mask-preview__image-group--hide[data-v-09033ad2]{opacity:0}", ""]);
// Exports
module.exports = exports;
